"use strict";

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _require = require('@solid/react/lib/util'),
    createTaskQueue = _require.createTaskQueue; // tslint:disable-line:no-var-requires


var evaluatorQueue = createTaskQueue();
/**
 * A GraphQL-LD query engine wrapper.
 * Inspired by https://github.com/solid/react-components/blob/master/src/ExpressionEvaluator.js
 */

var QueryEngine =
/*#__PURE__*/
function () {
  function QueryEngine(client) {
    _classCallCheck(this, QueryEngine);

    this.pending = null;
    this.client = client;
  }

  _createClass(QueryEngine, [{
    key: "destroy",
    value: function destroy() {
      this.pending = null;
      evaluatorQueue.clear(this);
    }
  }, {
    key: "evaluate",
    value: function evaluate(queryArgs, updateCallback) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var _this = this;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // Reset the state
                updateCallback({
                  loading: true,
                  error: undefined
                }); // Schedule the query evaluation

                _context.next = 3;
                return evaluatorQueue.schedule(function () {
                  return _this.evaluateScheduled(queryArgs, updateCallback);
                });

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
    }
  }, {
    key: "evaluateScheduled",
    value: function evaluateScheduled(queryArgs, updateCallback) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var promise, _ref, data, errors;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // Evaluate the query
                promise = this.pending = this.client.query(queryArgs);
                _context2.prev = 1;
                _context2.next = 4;
                return promise;

              case 4:
                _ref = _context2.sent;
                data = _ref.data;
                errors = _ref.errors;

                if (!(this.pending !== promise)) {
                  _context2.next = 9;
                  break;
                }

                return _context2.abrupt("return", false);

              case 9:
                // Handle the results
                if (errors) {
                  updateCallback({
                    loading: false,
                    error: errors[0]
                  });
                } else {
                  updateCallback({
                    loading: false,
                    data: data
                  });
                }

                _context2.next = 15;
                break;

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2["catch"](1);
                updateCallback({
                  loading: false,
                  error: _context2.t0
                });

              case 15:
                return _context2.abrupt("return", true);

              case 16:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[1, 12]]);
      }));
    }
  }]);

  return QueryEngine;
}();

exports.QueryEngine = QueryEngine;